import React from 'react'
import { ActivityIndicator, View } from 'react-native'
import { colors } from 'infra/color'

export const InitScreen = () => {
  return (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.white,
      }}
    >
      <ActivityIndicator color={colors.primary} />
    </View>
  )
}
